import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import {
  changeDateFormat,
  checkArray,
  checkNull,
  createSelectOptions,
  decimalValue,
  getBase64,
  parseStringToDate,
} from "../../../../../helpers";
import {
  getAddTransSubAccountDetails,
  changeSettingValue,
  saveFinanceSubAccountDetails,
  getDebitCreditAccountDetails,
  saveAccTransactionDetails,
} from "../../../../../Redux/actions";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import moment from "moment";

const AddTransaction = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    add_accounts_details,
    is_redirect_accounts_id,
    newDebitCreditDetail,
  } = useSelector((state) => state.settingReducer);
  const financeAcc = add_accounts_details?.data;
  let { id } = useParams();

  useEffect(() => {
    dispatch(getAddTransSubAccountDetails(`/${id}`));
    dispatch(changeSettingValue("is_redirect_accounts_id", false));
    return () => {
      dispatch(changeSettingValue("add_accounts_details", null));
      dispatch(changeSettingValue("is_redirect_accounts_id", false));
    };
  }, []);
  useEffect(() => {
    if (is_redirect_accounts_id) history.goBack();
  }, [is_redirect_accounts_id]);

  const initialTransForm = {
    transaction_id: checkNull(add_accounts_details?.newAccountId),
    transaction_account_id: checkNull(id),
    debit_or_credit: "",
    transaction_description_id: "",
    transaction_description_debit_type_id: "",
    transaction_description_credit_type_id: "",
    transaction_date: "",
    value_date: "",
    debit_account_id: "",
    debitsModel: "",
    credit_account_id: "",
    creditsModel: "",
    transaction_amount: "",
    file: "",
    transaction_id2: checkNull(add_accounts_details?.newAccountId2),
    transaction_account_id2: checkNull(id),
    debit_or_credit2: "",
    debit_or_credit2: "",
    transaction_description_id2: "",
    transaction_description_debit_type_id2: "",
    transaction_description_credit_type_id2: "",
    transaction_date2: "",
    value_date2: "",
    debit_account_id2: "",
    debitsModel2: "",
    credit_account_id2: "",
    creditsModel2: "",
    transaction_amount2: "",
    desc2: "",
  };

  const [addAccForm, setaddAccForm] = useState(initialTransForm);
  const [descTypeDebitLi, setDescTypeDebitLi] = useState(false);
  const [descTypeCreditLi, setDescTypeCreditLi] = useState(false);

  const accPrefix = add_accounts_details?.slug ?? "";
  useEffect(() => {
    const newAccForm = { ...addAccForm };
    console.log("newAccForm", newAccForm);
    if (checkNull(financeAcc?.transaction_description_id, false)) {
      newAccForm.transaction_description_id =
        financeAcc?.transaction_description_id;
    }
    setaddAccForm(newAccForm);
  }, [financeAcc]);

  useEffect(() => {
    if (checkNull(add_accounts_details?.debitCreditDetail, false)) {
      const newAccForm = { ...addAccForm };
      newAccForm.transaction_date = checkNull(
        add_accounts_details?.debitCreditDetail?.transactionDate,
        false
      )
        ? moment(
            add_accounts_details?.debitCreditDetail?.transactionDate
          ).toDate()
        : "";
      newAccForm.value_date = checkNull(
        add_accounts_details?.debitCreditDetail?.valueDate,
        false
      )
        ? moment(add_accounts_details?.debitCreditDetail?.valueDate).toDate()
        : "";
      newAccForm.debitsModel = checkNull(
        add_accounts_details?.debitCreditDetail?.debitsModel,
        false
      )
        ? add_accounts_details?.debitCreditDetail?.debitsModel
        : "";
      newAccForm.creditsModel = checkNull(
        add_accounts_details?.debitCreditDetail?.creditsModel,
        false
      )
        ? add_accounts_details?.debitCreditDetail?.creditsModel
        : "";
      newAccForm.debit_or_credit = checkNull(
        add_accounts_details?.debitCreditDetail?.transactionType,
        false
      )
        ? add_accounts_details?.debitCreditDetail?.transactionType
        : "";
      newAccForm.debit_account_id = checkNull(id) ? id : "";
      if (accPrefix == "L04" || accPrefix == "L05") {
        newAccForm.credit_account_id =
          checkNull(id, false) &&
          (addAccForm?.transaction_description_id == 1 ||
            addAccForm?.transaction_description_id == 2 ||
            addAccForm?.transaction_description_id == 7)
            ? id
            : "";
      }
      if (accPrefix == "L03" || accPrefix == "L06") {
        newAccForm.credit_account_id = checkNull(
          financeAcc?.default_payment_account_id,
          false
        )
          ? `${financeAcc?.default_payment_account_id}`
          : "";
      }
      if (accPrefix == "A4") {
        newAccForm.credit_account_id =
          checkNull(id, false) &&
          addAccForm?.transaction_description_id != 3 &&
          addAccForm?.transaction_description_id != 4
            ? `${id}`
            : "";
      } else {
        newAccForm.credit_account_id = checkNull(id) ? id : "";
      }
      setaddAccForm(newAccForm);
    }
  }, [add_accounts_details?.debitCreditDetail]);

  useEffect(() => {
    if (checkNull(newDebitCreditDetail, false)) {
      const newAccForm = { ...addAccForm };
      newAccForm.transaction_date2 = checkNull(
        newDebitCreditDetail?.transactionDate,
        false
      )
        ? moment(newDebitCreditDetail?.transactionDate).toDate()
        : "";
      newAccForm.value_date2 = checkNull(newDebitCreditDetail?.valueDate, false)
        ? moment(newDebitCreditDetail?.valueDate).toDate()
        : "";
      newAccForm.debitsModel2 = checkNull(
        newDebitCreditDetail?.debitsModel,
        false
      )
        ? newDebitCreditDetail?.debitsModel
        : "";
      newAccForm.creditsModel2 = checkNull(
        newDebitCreditDetail?.creditsModel,
        false
      )
        ? newDebitCreditDetail?.creditsModel
        : "";
      newAccForm.debit_or_credit2 = checkNull(
        newDebitCreditDetail?.transactionType,
        false
      )
        ? newDebitCreditDetail?.transactionType
        : "";
      newAccForm.debit_account_id2 = checkNull(id) ? id : "";
      newAccForm.credit_account_id2 = checkNull(id) ? id : "";
      setaddAccForm(newAccForm);
    }
  }, [newDebitCreditDetail]);

  const accFormChangeHandler = (input, val) => {
    const accType = input.indexOf("2") > -1 ? "2" : "";
    console.log("accFormChangeHandler", input, accType);
    if (input.indexOf("transaction_description_id") > -1) {
      if (accPrefix == "A04" || accPrefix == "A07" || accPrefix == "A05") {
        if (val != "other") {
          const newAccForm = { ...addAccForm };
          newAccForm[`${input}`] = val;
          if (parseInt(val) == 5) {
            accFormChangeHandler("transaction_description_id2", 4);
            // newAccForm.transaction_description_id2 = 4;
            newAccForm.desc2 = `${financeAcc?.name ?? ""} Sale`;
          }
          setDescTypeDebitLi(false);
          setDescTypeCreditLi(false);
          setaddAccForm(newAccForm);
        } else {
          setDescTypeDebitLi(true);
          setDescTypeCreditLi(true);
        }
      } else {
        if (val != "other") {
          setDescTypeDebitLi(false);
          setDescTypeCreditLi(false);
        } else {
          setDescTypeDebitLi(true);
          setDescTypeCreditLi(true);
        }
        setaddAccForm({ ...initialTransForm, [input]: val });
      }
      if (val != "") {
        dispatch(
          getDebitCreditAccountDetails(
            {
              slug: add_accounts_details?.slug ?? "",
              transactionType: val,
              subAccountId: id,
              descTypeDebit: addAccForm?.[`descTypeDebit${accType}`] ?? "",
              descTypeCredit: addAccForm?.[`descTypeCredit${accType}`] ?? "",
            },
            accType
          )
        );
      }
    } else if (
      input.indexOf("transaction_description_debit_type_id") > -1 &&
      val != ""
    ) {
      getDebitCreditAccountDetails(
        {
          slug: add_accounts_details?.slug ?? "",
          transactionType:
            addAccForm?.[`transaction_description_id${accType}`] ?? "",
          subAccountId: id,
          descTypeDebit: val ?? "",
          descTypeCredit: addAccForm?.[`descTypeCredit${accType}`] ?? "",
        },
        accType
      );
    } else if (
      input.indexOf("transaction_description_credit_type_id") > -1 &&
      val != ""
    ) {
      getDebitCreditAccountDetails(
        {
          slug: add_accounts_details?.slug ?? "",
          transactionType:
            addAccForm?.[`transaction_description_id${accType}`] ?? "",
          subAccountId: id,
          descTypeDebit: addAccForm?.[`descTypeDebit${accType}`] ?? "",
          descTypeCredit: val,
        },
        accType
      );
    } else {
      if (input.indexOf("credit_account_id") > -1) {
        let newCreditModalVal = "";
        if (val != "" && val.indexOf("_") > -1) {
          newCreditModalVal = val.split("_")?.["1"] ?? "";
        }
        accFormChangeHandler("creditsModel", newCreditModalVal);
      }
      setaddAccForm((prevState) => ({ ...prevState, [input]: val }));
    }
  };

  const onFileChangeEvent = (event) => {
    if (event?.target?.files[0]) {
      getBase64(event.target.files[0]).then((data) => {
        console.log("fileupload", data);
        accFormChangeHandler("file", data);
      });
      event.target.value = null;
    }
  };

  const submitAccFormHandler = () => {
    const newAddAccForm = { ...addAccForm };
    newAddAccForm.transaction_date = checkNull(
      newAddAccForm?.transaction_date,
      false
    )
      ? moment(newAddAccForm?.transaction_date).format("yyyy-MM-DD")
      : "";
    newAddAccForm.value_date = checkNull(newAddAccForm?.value_date, false)
      ? moment(newAddAccForm?.value_date).format("yyyy-MM-DD")
      : "";
    dispatch(saveAccTransactionDetails(`/${id}`, newAddAccForm));
  };

  const getTransactionCon = (transType = "") => {
    const transactionDescriptions = {
      ...add_accounts_details?.transactionDescriptions,
    };
    if ((accPrefix == "L04" || accPrefix == "L05") && transType !== "") {
      delete transactionDescriptions[2];
      delete transactionDescriptions[3];
      delete transactionDescriptions[4];
    }
    const isDisabled =
      (accPrefix == "A04" || accPrefix == "A07" || accPrefix == "A05") &&
      transType != ""
        ? true
        : false;
    return (
      <div class="row-fluid shifts">
        <div class="col-md-6">
          <ul class="ingredient-info edit-shift">
            <li>
              <label class="required">Transaction ID</label>
              <div class="input-group col-md-7">
                <p>{add_accounts_details?.[`newAccountId${transType}`]}</p>
              </div>
            </li>
            <li>
              <label class="required">Trans. Description</label>
              <div class="input-group select-div col-md-7">
                {transType == "" ? (
                  <select
                    name={`transaction_description_id${transType}`}
                    id={`transaction_description_id${transType}`}
                    onChange={(e) =>
                      accFormChangeHandler(
                        `transaction_description_id${transType}`,
                        e?.target?.value
                      )
                    }
                    value={
                      addAccForm?.[`transaction_description_id${transType}`]
                    }
                    className="required tType"
                    disabled={isDisabled}
                  >
                    <option value="">Select</option>
                    {createSelectOptions(transactionDescriptions)}
                  </select>
                ) : (
                  <input
                    type="text"
                    name={`transaction_description_id${transType}`}
                    className="required currency"
                    disabled={true}
                    value={addAccForm?.desc2}
                  />
                )}
              </div>
            </li>
            {descTypeDebitLi && (
              <li class="descTypeDebitLi">
                <label class="required">Trans. Desc. Debit Type</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name={`transaction_description_debit_type_id${transType}`}
                    id={`transaction_description_debit_type_id${transType}`}
                    onChange={(e) =>
                      accFormChangeHandler(
                        `transaction_description_debit_type_id${transType}`,
                        e?.target?.value
                      )
                    }
                    value={
                      addAccForm?.[
                        `transaction_description_debit_type_id${transType}`
                      ]
                    }
                    className="required"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.descTypeDebit)}
                  </select>
                </div>
              </li>
            )}
            {descTypeCreditLi && (
              <li class="descTypeCreditLi">
                <label class="required">Trans. Desc. Credit Type</label>
                <div class="input-group select-div col-md-7">
                  <select
                    name={`transaction_description_credit_type_id${transType}`}
                    id={`transaction_description_credit_type_id${transType}`}
                    onChange={(e) =>
                      accFormChangeHandler(
                        `transaction_description_credit_type_id${transType}`,
                        e?.target?.value
                      )
                    }
                    value={
                      addAccForm?.[
                        `transaction_description_credit_type_id${transType}`
                      ]
                    }
                    className="required descTypeCredit"
                  >
                    <option value="">Select</option>
                    {createSelectOptions(add_accounts_details?.descTypeCredit)}
                  </select>
                </div>
              </li>
            )}

            <li>
              <label class="required">Transaction Date</label>
              <div className="input-group col-md-7">
                <DatePicker
                  name={`transaction_date${transType}`}
                  autoComplete="new-password"
                  dateFormat="yyyy-MM-dd"
                  onChange={(val) =>
                    accFormChangeHandler(`transaction_date${transType}`, val)
                  }
                  selected={addAccForm?.[`transaction_date${transType}`]}
                  readOnly={true}
                />
              </div>
            </li>
            <li>
              <label class="required">Value Date</label>
              <div className="input-group col-md-7">
                <DatePicker
                  name={`value_date${transType}`}
                  autoComplete="new-password"
                  dateFormat="yyyy-MM-dd"
                  onChange={(val) =>
                    accFormChangeHandler(`value_date${transType}`, val)
                  }
                  selected={addAccForm?.[`value_date${transType}`]}
                  readOnly={true}
                />
              </div>
            </li>
            {console.log(
              "testttttt",
              transactionDescriptions?.[
                addAccForm?.transaction_description_id
              ] &&
                transactionDescriptions?.[
                  addAccForm?.transaction_description_id
                ].indexOf("Beginning Balance")
            )}
            <li>
              <label
                className={`${
                  checkNull(addAccForm?.transaction_description_id, false) &&
                  transactionDescriptions?.[
                    addAccForm?.transaction_description_id
                  ] &&
                  transactionDescriptions?.[
                    addAccForm?.transaction_description_id
                  ] == "Beginning Balance"
                    ? ""
                    : "required"
                }`}
              >
                Debit Account
              </label>
              <div class="input-group select-div col-md-7">
                <select
                  name={`debit_account_id${transType}`}
                  id={`debit_account_id${transType}`}
                  onChange={(e) =>
                    accFormChangeHandler(
                      `debit_account_id${transType}`,
                      e?.target?.value
                    )
                  }
                  value={addAccForm?.[`debit_account_id${transType}`]}
                  className={`debitA`}
                >
                  <option value="">Select Debit Account</option>
                  {createSelectOptions(
                    add_accounts_details?.debitCreditDetail?.debits
                  )}
                </select>
                {/* <?php echo $this->Form->hidden('debitsModel', array('class' => 'debitsModel'))?> */}
              </div>
            </li>
            <li>
              <label class="required">Credit Account</label>
              <div class="input-group select-div col-md-7">
                <select
                  name={`credit_account_id${transType}`}
                  id={`credit_account_id${transType}`}
                  onChange={(e) =>
                    accFormChangeHandler(
                      `credit_account_id${transType}`,
                      e?.target?.value
                    )
                  }
                  value={addAccForm?.[`credit_account_id${transType}`]}
                  className="creditA required"
                >
                  <option value="">Select Credit Account</option>
                  {createSelectOptions(
                    checkArray(add_accounts_details?.debitCreditDetail?.credits)
                      ? add_accounts_details?.debitCreditDetail?.credits.filter(
                          (p) => {
                            let resp = true;
                            if (
                              (accPrefix == "L04" || accPrefix == "L05") &&
                              transType == "" &&
                              addAccForm?.transaction_description_id > 2 &&
                              addAccForm?.transaction_description_id != 7
                            ) {
                              if (
                                addAccForm?.transaction_description_id > 0 &&
                                p?.id == addAccForm?.transaction_description_id
                              ) {
                                resp = true;
                              } else {
                                resp = false;
                              }
                            }
                            return resp;
                          }
                        )
                      : []
                  )}
                </select>
                {/* <?php echo $this->Form->hidden('creditsModel', array('class' => 'creditsModel'))?> */}
              </div>
            </li>
            <li>
              <label class="required">Transaction Amount</label>
              <div class="input-group col-md-7">
                <input
                  type="text"
                  name={`transaction_amount${transType}`}
                  className="required currency"
                  onChange={(e) =>
                    accFormChangeHandler(
                      `transaction_amount${transType}`,
                      e?.target?.value
                    )
                  }
                  value={addAccForm?.[`transaction_amount${transType}`]}
                />
              </div>
            </li>
            {transType == "" && (
              <li>
                <label for="invoice_file" class="required">
                  Attachment
                </label>{" "}
                <div class="input-group col-md-7 browse-sec">
                  <input
                    type="file"
                    class="required"
                    id="invoice_file"
                    onChange={onFileChangeEvent}
                  />
                </div>
              </li>
            )}
          </ul>
        </div>

        <div class="clear"></div>
        {checkFooter(transType)}
      </div>
    );
  };

  const getFormAccAccount = () => {
    let res = null;
    if (accPrefix == "L01") {
      res = getTransactionCon();
    } else if (accPrefix == "L04" || accPrefix == "L05") {
      res = getTransactionCon();
    } else if (accPrefix == "L03" || accPrefix == "L06") {
      res = getTransactionCon();
    } else if (accPrefix == "A04") {
      res = (
        <>
          {getTransactionCon()}
          {addAccForm?.transaction_description_id != "other" &&
            addAccForm?.transaction_description_id == 5 &&
            getTransactionCon(2)}
        </>
      );
    } else if (accPrefix == "A07") {
      res = (
        <>
          {getTransactionCon()}
          {addAccForm?.transaction_description_id != "other" &&
            addAccForm?.transaction_description_id == 5 &&
            getTransactionCon(2)}
        </>
      );
    } else if (accPrefix == "A05") {
      res = (
        <>
          {getTransactionCon()}
          {addAccForm?.transaction_description_id != "other" &&
            addAccForm?.transaction_description_id == 5 &&
            getTransactionCon(2)}
        </>
      );
    } else if (accPrefix == "E01") {
      // res = (
      // );
    } else if (financeAcc?.finance_type_id == "1") {
      // res = (
      // );
    } else if (financeAcc?.finance_type_id == "2") {
      // res = (
      // );
    } else {
      // res = (
      // );
    }
    return res;
  };

  const footerCon = () => {
    return (
      <div class="btns col-4 d-flex justify-content-end py-4 col-12">
        <input
          type="button"
          value="Submit"
          onClick={() => submitAccFormHandler()}
          id="submitBut"
        />
        <input
          type="button"
          value="Cancel"
          onClick={() => history.goBack()}
          id="cancelBut"
        />
      </div>
    );
  };

  const checkFooter = (transType) => {
    if (
      transType == "" &&
      (accPrefix == "A04" || accPrefix == "A07" || accPrefix == "A05") &&
      addAccForm?.transaction_description_id == 5
    ) {
      return null;
    } else {
      return footerCon();
    }
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="top-header-sec">
              <div className="col-12 mt-3">
                <h4 className="event-alert br-btm-0">
                  Transaction Details
                </h4>

                <div className="shadowclass mt-0">{getFormAccAccount()}</div>
              </div>
            </div>

            <div className="clearfix"> &nbsp; </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default AddTransaction;
